import {h, Component} from 'preact';
import cx from 'classnames';
import SizedImage from '../../common/SizedImage';
import {Corpus} from '@modules/lazy-imports';

const optionGroup = {
    rule: 'md:border-b border-grey-lighter border-solid',
    title: 'card-option-title ellipsis text-base pt-1 mb-1 leading-tight hidden md:block',
    root: 'card-option-list mt-4 mb-0',
    list: 'grid-col-3 grid-gap-1 list-reset',
    item: 'card-option-item flex-1 self-center leading-collapse m-0 p-0',
    thumbnail: 'w-full p-1 border border-solid border-grey-lighter hover:border-grey-dark rounded-sm'
};

const carousel = {
    root: 'carousel',
    listWrap: 'carousel-list-container',
    list: 'carousel-list'
};

class OptionGroupList extends Component {

    state = {
        selected: null
    };

    componentDidMount () {
        Corpus().then( () => $( this.carousel ).corpus( 'carousel' ) );
    }

    handleSelect = index => {
        const selectedOption = this.props.list[index];
        this.setState( {selectedOption} );
        this.props.onSelect( selectedOption );
    };

    renderOptions ( list ) {
        return list.map( ( {name, images}, index ) => {
            const thumbnailSrc = images.length && images[0].src;
            return (
                <li style={{minWidth: 50}} className={optionGroup.item} index={index}
                    onMouseEnter={() => this.handleSelect( index )}>
                    <SizedImage className={optionGroup.thumbnail} src={thumbnailSrc} width={56} alt={name}/>
                </li>
            );
        } )
    }

    render () {

        const showIfActive = this.props.isActive ? 'grid' : 'hidden';
        const option = this.state.selectedOption;

        return (
            <div className="card-options">
                <h3 className={optionGroup.title}>
                    {option ? option.name : <span>&nbsp;</span>}
                </h3>
                <hr className={optionGroup.rule}/>
                <ul className={cx( optionGroup.root, showIfActive, optionGroup.list )}>
                    {this.renderOptions( this.props.list )}
                </ul>
            </div>
        );
    }
}

export default OptionGroupList;

